module.exports = __webpack_public_path__ + "img/namibia.18802c4.webp";